import React from 'react';
import { Link } from 'gatsby';

const StateLink = ({ to, children, ...props }) => {
    return (
        <Link {...props} to={to} state={{ iStoriez: true }}>
            {children}
        </Link>
    );
};

export default StateLink;
